import React, { useState } from "react";
import { Link, useHistory } from "react-router-dom";
import "./HeaderMobile.scss";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";

function Header() {
  const [menuAtivo, setMenu] = useState(false);

  let history = useHistory();
  return (
    <>
      <div
        className={!menuAtivo ? "overlay" : "overlay ativo"}
        onClick={() => {
          setMenu(!menuAtivo);
        }}
      ></div>
      <div className="icone">
        {!menuAtivo ? (
          <MenuIcon
            className="icon-mobile"
            fontSize="large"
            onClick={() => {
              setMenu(!menuAtivo);
            }}
          />
        ) : (
          <CloseIcon
            className="icon-mobile"
            fontSize="large"
            onClick={() => {
              setMenu(!menuAtivo);
            }}
          />
        )}
      </div>
      <div className={!menuAtivo ? "menus" : "menus ativo"}>
        <Link
          to="/"
          onClick={() => {
            setMenu(false);
          }}
        >
          <div className="item">Home</div>
        </Link>
        <span
          to="/"
          onClick={() => {
            setMenu(false);
            if (history.location.pathname === "/") {
              document.getElementById("quem-somos").scrollIntoView({
                behavior: "smooth",
              });
            } else {
              history.push("/");
              setTimeout(() => {
                document.getElementById("quem-somos").scrollIntoView({
                  behavior: "smooth",
                });
              }, 300);
            }
          }}
        >
          <div className="item">Quem somos</div>
        </span>
        <Link
          to="/produtos"
          onClick={() => {
            setMenu(false);
          }}
        >
          <div className="item">Produtos e Serviços</div>
        </Link>
        <span
          to="/"
          onClick={() => {
            setMenu(false);
            if (history.location.pathname === "/") {
              document.getElementById("form-home").scrollIntoView({
                behavior: "smooth",
              });
            } else {
              history.push("/");
              setTimeout(() => {
                document.getElementById("form-home").scrollIntoView({
                  behavior: "smooth",
                });
              }, 300);
            }
          }}
        >
          <div className="item">Contato e suporte</div>
        </span>
      </div>
    </>
  );
}

export default Header;
